import { render, staticRenderFns } from "./programPacksPage.vue?vue&type=template&id=f647f1ca&scoped=true&"
import script from "./programPacksPage.vue?vue&type=script&lang=ts&"
export * from "./programPacksPage.vue?vue&type=script&lang=ts&"
import style0 from "./programPacksPage.vue?vue&type=style&index=0&id=f647f1ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f647f1ca",
  null
  
)

export default component.exports